export const Marks = ({xScale, yScale, data, xValue, yValue}) => 
  					data.map(d => (
            <rect className="mark"
              key={yValue(d)}
              x={0}
              y={yScale(yValue(d))}
              width={xScale(xValue(d))}
              height={yScale.bandwidth()}
            >
                <title>{xValue(d)}</title>
              </rect>
  					))
